import { useMemo } from 'react'
import { DropdownItem } from '../../../../types'
import { isEmpty } from '../../../../utils/stringUtils'
import { ActivationObject } from '../../../providers/ActivationObjectProvider/types'
import { ContactPersonRoleList } from '../constants'
import { Step4FormOptionsProps, Step4FormProps } from '../types'

const useStep4FormOptions = (form: Step4FormProps['form'], activationObject?: ActivationObject): Step4FormOptionsProps => {
    const personContacts = form.watch('personContacts')
    const jablotronAppEmails: DropdownItem[] = useMemo(
        () =>
            personContacts
                ? personContacts
                      .filter((x) => !isEmpty(x.email))
                      .map((field) => {
                          return { value: field.email || '', label: field.email || '' }
                      })
                : [],
        [personContacts]
    )

    return {
        jablotronAppEmails,
        contactPersonRoles: ContactPersonRoleList,
    }
}

export default useStep4FormOptions
